export const UF_OPTIONS = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

export const formatTaxValue = (value: string) => {
  if (!value) return "";
  let cleanValue = value.replace(/\D/g, "");
  if (cleanValue.length > 2) {
    cleanValue = cleanValue.replace(/(\d+)(\d{2})$/, "$1,$2");
  }
  return cleanValue;
};
